export const TRANSACTIONS_TAGS = {
  TRANSACTIONS_TAG: "Transactions",
};
